import { match } from 'path-to-regexp';

import { routes } from '~/constants/routes';

export const pathMatching = (
  path: string,
  pathToMatch = window.location.pathname
) => {
  if (path === '/*' || path === pathToMatch) {
    return true;
  }

  // remove trailing slash
  if (pathToMatch.endsWith('/')) {
    pathToMatch = pathToMatch.slice(0, -1);
  }

  const pathToMatchParts = pathToMatch.split('/');
  const pathParts = path.split('/');

  if (pathParts.length !== pathToMatchParts.length) {
    return false;
  }

  return pathParts.every((part, index) => {
    if (part === '*' || part.startsWith(':')) {
      return true;
    }

    return part === pathToMatchParts[index];
  });
};

export const getCurrentRouteRecord = (pathname: string) => {
  const route = Object.values(routes).find((r) =>
    match(r.path, { decode: decodeURIComponent })(pathname)
  );

  return { route };
};
